<template>
  <div v-if="visible" class="modal_wrapper">
    <div class="modal_container">
      <div class="modal_title d-flex justify-content-between py-2 px-3">
        <h4 class="my-0">
          {{ modalTitle }}
        </h4>
        <div class="cursor-pointer tooltip-wrapper pointer">
          <i class="fa fa-times" @click.prevent="$emit('close')"></i>
          <span class="custom-tooltip closetooltipposition">Close</span>
        </div>
      </div>
      <div
        class="modal__upload__content d-flex flex-column justify-content-between pb-4 pt-2 px-4"
      >
        <div class="align-items-center" v-if="!isSoAImport">
          <div class="mb-4 float-right">
            Download the template and follow the format
            <span class="ml-2"
              ><img
                class="cursor-pointer"
                src="../../assets/img/download_1.png"
                alt="Download"
                @click="$emit('download-template')"
                :disabled="showLoading"
            /></span>
          </div>
        </div>
        <div class="input-group">
          <input
            accept=".xls,.xlsx,.jpg,.jpeg,.png,.pdf,.docx"
            id="InPutFile"
            type="file"
            class="form-control my-2 my-lg-0"
            @change="$emit('file-change', $event)"
          />
          <span class="input-group-append d-flex align-items-center">
            <button
              type="button"
              class="stdy_upload_btn mr-0 py-1"
              @click="$emit('import-study')"
              :disabled="showLoading"
            >
              <div class="d-flex align-items-center" v-if="showLoading">
                <img
                  class="loading-img"
                  width="20"
                  src="../../assets/img/loading.webp"
                  alt="Wait while the document is added"
                />
              </div>
              <div v-else>{{ importButtonLabel }}</div>
            </button>
          </span>
        </div>
        <span class="errorClass" v-if="hasFileValidationError">
          {{ $t("navigations.please upload a file") }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ImportStudyModal",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    showLoading: {
      type: Boolean,
      default: false,
    },
    hasFileValidationError: {
      type: Boolean,
      default: false,
    },
    importType: {
      type: String,
      default: "study",
    },
  },
  emits: ["close", "download-template", "file-change", "import-study"],
  computed: {
    isSoAImport() {
      return (this.importType || "").toLowerCase() === "soa";
    },
    modalTitle() {
      return this.isSoAImport ? this.$t("navigations.Concept map Builder") : this.$t("navigations.import study");
    },
    importButtonLabel() {
      return this.$t("navigations.import");
    },
  },
};
</script>

<style scoped>
.modal_wrapper {
  position: fixed;
  inset: 0;
  background: rgb(0 0 0 / 18%);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  z-index: 3000;
}
.modal_container {
  position: fixed;
  width: min(40%, 90%);
  border-radius: 4px;
  background: #fff;
  overflow-x: hidden;
}
.modal_title {
  background-color: #618bd7;
  color: #fff;
}
.stdy_upload_btn {
  text-align: center;
  background-color: #618bd7 !important;
  border-color: #618bd7 !important;
  color: white !important;
  padding: 0.43rem 0.4rem;
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  transition: all 0.3s ease-in-out !important;
}
.upload_btn img {
  mix-blend-mode: color-dodge;
}
.tooltip-wrapper {
  position: relative;
  display: inline-block;
}
.custom-tooltip {
  visibility: hidden;
  width: 60px;
  background-color: #555;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  bottom: 70%;
  left: 88%;
  margin-left: -30px;
  opacity: 0;
  transition: opacity 0.3s;
  font-size: 12px;
}
.tooltip-wrapper:hover .custom-tooltip {
  visibility: visible;
  opacity: 1;
}
.closetooltipposition {
  bottom: -10px !important;
}
</style>
